// tslint:disable:jsx-no-lambda
// tslint:disable:object-literal-sort-keys
import { Link } from '@reach/router';
import { useContext } from 'react';
import * as React from 'react';
import { ButtonFilled } from '../../../components/ui';
import { AccountContext } from '../../../context/account';
import { NotebookContext } from '../../../context/NotebookContext';
import client from '../../../lib/client';
import redirect from '../../../lib/redirect';
import {
  DeleteNotebookMutation,
  DeleteNotebookMutationVariables
} from '../../../queries/__generated__/DeleteNotebookMutation';
import { NotebooksQueryVariables } from '../../../queries/__generated__/NotebooksQuery';
import { deleteNotebookMutation, notebooksQuery } from '../../../queries/notebooks';

const deleteNotebook = async (notebookId: string, accountId: string) => {
  await client
    .mutate<DeleteNotebookMutation, DeleteNotebookMutationVariables>({
      mutation: deleteNotebookMutation,
      variables: { id: notebookId },
      refetchQueries: [
        {
          query: notebooksQuery,
          variables: { input: { accountId } } as NotebooksQueryVariables
        }
      ]
    })
    .then(() => {
      localStorage.setItem('selectedNotebookId', 'null');
      redirect('/');
    });
};

const NotebookDelete: React.FC = () => {
  const accountContext = useContext(AccountContext);
  const { notebook } = useContext(NotebookContext);

  return (
    <div className="min-vh-100 flex flex-column items-center justify-center pa3">
      <div className="tc mw6">
        <p className="serif lh-copy measure-narrow mt0 mb4">
          You’ll lose all your data for this space. Are you sure you want to delete it?
        </p>

        <ButtonFilled
          className="mb3"
          onClick={() => deleteNotebook(notebook.id, accountContext.selectedAccountId)}
          data-testid="confirm-delete-button"
        >
          Yes, Delete
        </ButtonFilled>
        <Link
          className="db f6 blue hover-navy"
          to={`/notebook/settings`}
          data-testid="cancel-delete-button"
        >
          No, Don’t Delete
        </Link>
      </div>
    </div>
  );
};

export default NotebookDelete;
